import React, { useState, useEffect } from 'react';
import {
  convertDateTimeToIsoString,
  createDateFromBackendDate,
  createDateTimeFromBackendDate,
} from '../../util/dateUtil';
import { patchMatchDateTime } from '../../util/api/requests';
import DatePicker from 'react-datepicker';
import { et } from 'date-fns/locale';
import { Button, OverlayTrigger, Popover, Badge } from 'react-bootstrap';

const DATEPICKER_WIDTH = '350px';
const DATEPICKER_TIME_INTERVAL_IN_MINUTES = 15;

const DateTimeOverlayPopover = ({
  season,
  selectedDateTime,
  matchId,
  forceLeagueCalendarUpdate,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    setSelectedDate(
      selectedDateTime
        ? createDateTimeFromBackendDate(selectedDateTime)
        : createDateFromBackendDate(season.startDate)
    );
  }, [season, selectedDateTime]);

  const saveMatchDateTime = async () => {
    try {
      await patchMatchDateTime(matchId, {
        matchDateTime: selectedDate
          ? convertDateTimeToIsoString(selectedDate)
          : null,
      });
      forceLeagueCalendarUpdate();
      document.body.click();
    } catch (error) {
      console.error('Error saving match date/time:', error);
    }
  };

  const popover = (
    <Popover id="datetime-popover" style={{ minWidth: DATEPICKER_WIDTH }}>
      <Popover.Title as="h3">Muuda mängu aega</Popover.Title>
      <Popover.Content>
        <DatePicker
          selected={selectedDate}
          locale={et}
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={DATEPICKER_TIME_INTERVAL_IN_MINUTES}
          minDate={createDateFromBackendDate(season.startDate)}
          maxDate={createDateFromBackendDate(season.endDate)}
          dateFormat="dd.MM.yyyy HH:mm"
          placeholderText="Kuupäev ja kellaaeg"
          onChange={setSelectedDate}
        />
        <Button disabled={!selectedDate} onClick={saveMatchDateTime}>
          Salvesta
        </Button>
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      overlay={popover}
      rootClose
    >
      <Badge style={{ cursor: 'pointer' }} variant="primary">
        Muuda aega
      </Badge>
    </OverlayTrigger>
  );
};

export default DateTimeOverlayPopover;
